module.exports = __webpack_public_path__ + "assets/img/247501.40b655eb.svg";